import actions from './actions';

const initState = {
  files: [],
  total: 0,
  uploadedFiles: [],
  error: false,
  message: '',
  loading: false,
  currentPage: 1,
  pageSize: 20,
  totalPages: 0,
};

export default function mediaReducer(state = initState, action) {
  switch (action.type) {
    case actions.DELETE_FILE:
    case actions.LOAD_MEDIA:
      return {
        ...state,
        loading: true,
        error: false,
        message: '',
        currentPage: action.currentPage || 1,
        pageSize: action.limit || 20
      };
    case actions.CREATE_FILE:
      return {
        ...state,
        loading: true,
        error: false,
        message: ''
      };
    case actions.LOAD_MEDIA_SUCCESS:
      return {
        ...state,
        files: action.files,
        total: action.total,
        currentPage: action.currentPage || 1,
        totalPages: Math.ceil(action.total / state.pageSize),
        error: false,
        message: '',
        loading: false,
      };
    case actions.LOAD_MEDIA_ERROR:
    case actions.DELETE_FILE_ERROR:
    case actions.CREATE_FILE_ERROR:
      return {
        ...state,
        error: true,
        message: action.message,
        loading: false,
      };
    case actions.CREATE_FILE_SUCCESS: {
      const { files } = state;
      const { file } = action;
      return {
        ...state,
        loading: false,
        error: false,
        message: '',
        files: [ file, ...files ],
        total: state.total + 1,
      };
    }
    case actions.DELETE_FILE_SUCCESS: {
      const { files } = state;
      return {
        ...state,
        loading: false,
        error: false,
        message: '',
        files: files.filter(f => f.eid !== action.eid),
        total: state.total - 1,
      };
    }
    default:
      return state;
  }
}
